import { Legend, Pie3D } from './Charts'
import { TASK_HEALTH_COLORS } from './palette'
import { formatNumber } from '../../lib/format'

/**
 * Task Completion 3D pie — the "Non-repeat Task Completion" / "Repeat Task
 * Completion" cards on the Company Admin dashboard (company-wide) and the
 * user-panel dashboard (the viewer's department). Shared so the two can't
 * drift. Takes one side of a `repeatSplit`: `{ total, completed, overdue,
 * onTrack }`. Slices are the mutually-exclusive To Do (open, not past due) /
 * Completed / Overdue split, so they sum to that side's total; the legend
 * shows counts + shares and the caption the completion rate.
 */
export function TaskCompletionPie({ part, empty }) {
  const completed = part?.completed ?? 0
  const overdue = part?.overdue ?? 0
  const toDo = part?.onTrack ?? 0
  const total = completed + overdue + toDo
  if (total === 0) {
    return (
      <p className="text-sm text-[color:var(--color-ink-muted)] py-6 text-center italic">
        {empty}
      </p>
    )
  }
  const segments = [
    { label: 'To Do', value: toDo, color: TASK_HEALTH_COLORS.onTrack },
    { label: 'Completed', value: completed, color: TASK_HEALTH_COLORS.completed },
    { label: 'Overdue', value: overdue, color: TASK_HEALTH_COLORS.overdue },
  ]
  return (
    <div className="flex flex-col gap-4 py-1">
      <Pie3D segments={segments} width={340} />
      <p className="m-0 text-center text-sm text-[color:var(--color-ink-muted)] tabular-nums">
        <span className="font-medium text-[color:var(--color-ink-strong)]">
          {Math.round((completed / total) * 100)}% completed
        </span>{' '}
        · {formatNumber(completed)} of {formatNumber(total)}
      </p>
      <Legend
        segments={segments}
        formatValue={(v, pct) => `${formatNumber(v)} · ${pct}%`}
      />
    </div>
  )
}
